import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { siteAccountParamsCreate, siteAccountParamsDelete, siteAccountParamsList, siteAccountParamsUpdate } from '@/api/siteAccountParams';
import { AppError } from '@/errors/appError';
import { isRequestCanceled } from '@/services/baseService';
import { ISiteAccountParamsApiListResponse, ISiteAccountParamUpdateParams, ISiteAccountParamUpdateResponse } from '@/types/siteAccountParams';

export const siteAccountParamsService = {
    async listByAccountId(accountId: number, config?: AxiosRequestConfig): Promise<AxiosResponse<ISiteAccountParamsApiListResponse>> {
        try {
            return await siteAccountParamsList(accountId, config);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Site account params API Error:', e);
            throw new AppError('Unable to load account params, request error', { cause: e });
        }
    },

    async create(params: ISiteAccountParamUpdateParams): Promise<AxiosResponse<ISiteAccountParamUpdateResponse>> {
        try {
            return await siteAccountParamsCreate(params);
        } catch (e) {
            console.error('Site account params create API Error:', e);
            throw new AppError('Unable to create account param, request error', { cause: e });
        }
    },

    async update(params: ISiteAccountParamUpdateParams): Promise<AxiosResponse<ISiteAccountParamUpdateResponse>> {
        try {
            return await siteAccountParamsUpdate(params);
        } catch (e) {
            console.error('Site account params update API Error:', e);
            throw new AppError('Unable to update account param, request error', { cause: e });
        }
    },

    async delete(params: ISiteAccountParamUpdateParams): Promise<AxiosResponse<ISiteAccountParamUpdateResponse>> {
        try {
            return await siteAccountParamsDelete(params);
        } catch (e) {
            console.error('Site account params delete API Error:', e);
            throw new AppError('Unable to delete account param, request error', { cause: e });
        }
    },
};
